<template>
<div class="component ">

    <div class="tabs tpTabs is-fullwidth is-boxed">
        <ul>
            <li class="tpTab" :class="{'is-active':activeTab=='market'}" @click="activeTab='market'"><a>{{$t('enaq_translation_meetingpoint_market')}}</a></li>
            <li class="tpTab" :class="{'is-active':activeTab=='groups'}" @click="activeTab='groups'"><a>{{$t('enaq_translation_meetingpoint_groups')}}</a></li>
            <li class="tpTab" :class="{'is-active':activeTab=='nbhelp'}" @click="activeTab='nbhelp'"><a>{{$t('enaq_translation_meetingpoint_nbhelp')}}</a></li>
            <li class="tpTab" :class="{'is-active':activeTab=='ressources'}" @click="activeTab='ressources'"><a>{{$t('enaq_translation_meetingpoint_ressources')}}</a></li>
            <li class="tpTab" :class="{'is-active':activeTab=='highscore'}" @click="activeTab='highscore'"><a>{{$t('enaq_translation_meetingpoint_highscore')}}</a></li>

        </ul>
    </div>
    <transition name="xmeetingPointTabTransition">
<div class="meetingPointContent">
        <div v-if="activeTab=='market'">
            <sales />
        </div>


        <div v-if="activeTab=='groups'">
            <groups />
        </div>
        <div v-if="activeTab=='nbhelp'">
            <nachbarschaftshilfe />
        </div>
        <div v-if="activeTab=='ressources'">
            <ressources />
        </div>
        <div v-if="activeTab=='highscore'">
            <highscore />
        </div>
        </div>
    </transition>
</div>
</template>

<script>
import groups from '@/views/users/groups.vue';
import sales from '@/views/users/sales.vue';
import nachbarschaftshilfe from '@/views/users/nachbarschaftshilfe.vue';
import ressources from '@/views/users/ressources.vue';
import highscore from '@/views/users/highscore.vue';

export default {
    name: 'meetingpoint',
    props: [],
    components: {
        groups,
        sales,
        nachbarschaftshilfe,
        ressources,
        highscore
    },
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            activeTab: "market"
        }
    },
    methods: {},
    computed: {},
}
</script>

<style scoped>
.tabs li {
    font-weight: bolder;
}
.meetingPointContent{margin-top: 3em;}
.tpTabs .is-active a {
    color: #F0AD12 !important
}

.meetingPointTabTransition-enter-active,
.meetingPointTabTransition-leave-active {
    transition: all 2s;
    display: block;
    position: absolute;
}

.meetingPointTabTransition-enter {
    margin-left: 100px;
}

.meetingPointTabTransition-enter-to {
    margin-left: 1px;

}

.meetingPointTabTransition-leave {
    margin-right: 1px;
}

.meetingPointTabTransition-leave-to {
    margin-right: 1000px;

}
</style>
